import { formatPrice } from "../../../../utils/formatPrice";
import DeleteIcon from "../../../Common/svg/deleteicon";
import Attachments from "./attachments";

const DeliveringInfo = ({
  curiorInfo,
  setCuriorInfo,
  attachments,
  setAttachments,
  formErrors,
  currencyFactor
}) => {
  const handleAddrow = () => {
    setAttachments((prev) => ([
      ...prev,
      {
      id: prev.length + 1,
    }]));
  };

  return (
    <div className="row">
      <label htmlFor="" className="form-label">طريقة الحساب التوصيل</label>
      <div className="col-md-2">
        <label htmlFor="" className="form-label">حساب التوصيل</label>
        <select
           className={`form-control ${formErrors.commission_type?"is-invalid":""}`}
          value={curiorInfo.commission_type}
          onChange={(e) =>
            setCuriorInfo((prev) => ({
              ...prev,
              commission_type: e.target.value,
            }))
          }  
        >
          <option value="">اختر نوع الحساب</option>
          <option value="subscription">ثابت</option>
          <option value="commission">نسبة</option>
        </select>
        {formErrors.commission_type && <div className=" d-block invalid-feedback">يرجي اختيار نوع حساب التوصيل</div>}
      </div>
      <div className="col-md-10 d-flex align-items-end">
        <input
          type="text"
          className={`form-control ${formErrors.commission_amount?"is-invalid":""}`}
          value={curiorInfo.commission_amount}
          onChange={(e) =>
            setCuriorInfo((prev) => ({
              ...prev,
              commission_amount: +e.target.value,
            }))
          }
          placeholder="أدخل قيمة الحساب"   
        />
         {formErrors.commission_amount && <div className=" d-block invalid-feedback">
                 {formErrors.commission_amount} </div>}
      </div>

      <div className="d-flex justify-content-between">
        <h6>المرفقات</h6>
        <button className="btn btn-primary" onClick={handleAddrow}>إضافة مرفق +</button>
      </div>   

   
  
    </div>
  );
};
export default DeliveringInfo;
